import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { messageClear } from "../store/reducers/authReducer"; /*obtneerr la url de envio*/
import toast from "react-hot-toast";
import { FadeLoader } from "react-spinners";

const Blogs = () => {
  const navigate = useNavigate();
  const { loader, errorMessage, successMessage } = useSelector(state => state.auth);

  const dispatch = useDispatch();

  /*cambiar el dispath*/

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  
  }, [successMessage, errorMessage,  navigate, dispatch]);

  return (
    <div>
      {loader && (
        <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <Header />
      <div className="bg-slate-200 mt-4">
        <div className="w-full justify-center items-center p-10">
          <div className="max-w-6xl mx-auto bg-white rounded-md">
            <div className="px-8 py-8">
              <h2 className="text-center w-full text-xl text-slate-600 font-bold">Blog en construcción </h2>
              <div></div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Blogs;
